import React from 'react'

export const UseTextTemplateContext = React.createContext(false)
